import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Leaf, Mail, Smartphone, ArrowLeft } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import { GoogleAuthButton } from '@/components/auth/GoogleAuthButton';
import { EmailAuthForm } from '@/components/auth/EmailAuthForm';
import { PhoneAuthForm } from '@/components/auth/PhoneAuthForm';

export default function Auth() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-background flex flex-col safe-area-pt safe-area-pb">
      {/* Header */}
      <header className="h-14 flex items-center px-4 border-b border-border">
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={() => navigate('/')}
          className="h-10 w-10 -ml-2"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
      </header>

      <div className="flex-1 flex items-center justify-center p-4 leaf-pattern">
        <div className="w-full max-w-sm animate-grow">
          {/* Logo */}
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full gradient-nature mb-3">
              <Leaf className="h-7 w-7 text-primary-foreground" />
            </div>
            <h1 className="text-xl font-bold text-foreground font-display">
              PlantID
            </h1>
            <p className="text-sm text-muted-foreground mt-1">
              Identifique plantas com IA
            </p>
          </div>

          <Card className="glass-card border-0 shadow-lg">
            <CardHeader className="text-center pb-2 px-4 pt-5">
              <CardTitle className="text-lg">Entrar ou Cadastrar</CardTitle>
              <CardDescription className="text-sm">
                Escolha como deseja continuar
              </CardDescription>
            </CardHeader>

            <CardContent className="space-y-4 px-4 pb-5">
              {/* Google Auth */}
              <GoogleAuthButton />

              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <Separator className="w-full" />
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-card px-2 text-muted-foreground">ou</span>
                </div>
              </div>

              {/* Tabs for Email and Phone */}
              <Tabs defaultValue="phone" className="w-full">
                <TabsList className="grid w-full grid-cols-2 h-11">
                  <TabsTrigger value="phone" className="flex items-center gap-2 h-9">
                    <Smartphone className="h-4 w-4" />
                    SMS
                  </TabsTrigger>
                  <TabsTrigger value="email" className="flex items-center gap-2 h-9">
                    <Mail className="h-4 w-4" />
                    Email
                  </TabsTrigger>
                </TabsList>

                <TabsContent value="phone" className="mt-4">
                  <PhoneAuthForm onSuccess={handleSuccess} />
                </TabsContent>

                <TabsContent value="email" className="mt-4">
                  <EmailAuthForm onSuccess={handleSuccess} />
                </TabsContent>
              </Tabs>
            </CardContent>
          </Card>

          <p className="text-center text-xs text-muted-foreground mt-4 px-4">
            Ao continuar, você concorda com nossos Termos de Serviço e Política de Privacidade.
          </p>
        </div>
      </div>
    </div>
  );
}
